import { Box, Chip } from "@mui/material";

const StatusChip = ({ config }) => {
  const Icon = config.icon;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {/* <Icon sx={{ fontSize: 18, color: config.color }} /> */}
      <Chip
      // icon={<Icon sx={{ fontSize: 18, color: config.color}} />}
        label={config.label}
        size="small"
        sx={{
          color: config.textColor,
          backgroundColor: config.background,
          fontWeight: 500,
          fontSize: "0.75rem",
        }}
      />
    </Box>
  );
};

export default StatusChip;
